import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: ${({ theme }) => theme.spacing(2)};

  width: 100%;
  height: 100%;

  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;
